export default __webpack_public_path__ + "static/media/special.a3235cb3.svg";